import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock as LockIcon } from "lucide-react";
import api, { authStorage, formatApiErrorDetail } from "@/lib/api";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      authStorage.setToken(data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A2540] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-block">
            <Logo variant="light" size="lg" />
          </div>
          <h1 className="heading-font text-2xl text-white mt-8">Yönetici Paneli</h1>
          <p className="text-white/60 text-sm mt-2">Devam etmek için giriş yapın</p>
        </div>
        <form
          onSubmit={onSubmit}
          className="bg-white p-8 space-y-5"
          data-testid="admin-login-form"
        >
          <div>
            <label className="block text-xs uppercase tracking-wider text-slate-500 mb-2">
              E-posta
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 border border-slate-200 focus:border-[#0066FF] outline-none"
              required
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-slate-500 mb-2">
              Şifre
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-slate-200 focus:border-[#0066FF] outline-none"
              required
              data-testid="admin-login-password"
            />
          </div>
          {error && (
            <div className="text-sm text-red-600 bg-red-50 px-4 py-3" data-testid="admin-login-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#0A2540] hover:bg-[#0066FF] disabled:opacity-60 text-white py-3 font-semibold transition-colors flex items-center justify-center gap-2"
            data-testid="admin-login-submit"
          >
            <LockIcon size={16} />
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
      </div>
    </div>
  );
}
